module.exports = __webpack_public_path__ + "41481d447b35c258e7b7e4c3a25924cf.png";